import { render } from "./AdminAcceptWithdrawal.vue?vue&type=template&id=36e29cd8"
import script from "./AdminAcceptWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminAcceptWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__